import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Typography } from "@mui/material";
import ChargePointStrategyDetailsComponent from "../chargePointStrategy/ChargePointStrategyDetailsComponent";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyValueTextElement from "../../common/KeyValueTextElementComponent";
import { buttonElementModel } from "../../../models/common/buttonElement.model";
import ButtonElementComponent from "../../common/ButtonElementComponent";
import ChargePointStrategyAccordionElementComponent from "../chargePointStrategy/ChargePointStrategyAccordionElementComponent";
import ChargePointChargingPriceElementComponent from "../ChargePointChargingPriceElementComponent";

export const ChargePointDetailsStepComponent = ({ chargePoint, handleNext, handleBack }) => {
  const { externalApi_ChargePointDetailsDTO } = chargePoint;

  const getSubmitButtonElement = () => {
    const buttonElementProps = {
      ...buttonElementModel,
      label: "הבא",
      onClick: handleNext,
      className: "marginTop10",
    };
    return <ButtonElementComponent buttonElementProps={buttonElementProps} />;
  };

  return (
    <div className="flexColumn textAlignCenter">
      <KeyValueTextElement keyLabel="עמדת טעינה" valueText={externalApi_ChargePointDetailsDTO.nickname} />
      <KeyValueTextElement keyLabel="זרם טעינה" valueText={`${externalApi_ChargePointDetailsDTO.currentMaxAmp}A`} />
      <ChargePointChargingPriceElementComponent chargePoint={chargePoint} />
      {getSubmitButtonElement()}
    </div>
  );
};

export default ChargePointDetailsStepComponent;
